import { ADL_INDEPENDENCE_ANSWERS } from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  ownCoding,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const SECTIONS: InstrumentSection[] = [
  {
    id: 'questions',
    items: [
      'Bathing',
      'Dressing',
      'Toileting',
      'Transferring',
      'Continence',
      'Feeding',
    ].map((label) =>
      scoredItem(
        ownCoding(`adl-${label.toLowerCase()}`, label),
        ADL_INDEPENDENCE_ANSWERS
      )
    ),
  },
]

// 6 is full function, 0 fully dependent; the form shows the score alone.
export const ADL_TEMPLATE: InstrumentTemplate = {
  id: 'adl',
  version: '1',
  panel: ownCoding('adl-panel', 'Katz index of independence in ADL'),
  title: 'Katz Index of Independence in Activities of Daily Living (ADL)',
  reference: 'https://www.alz.org/careplanning/downloads/katz-adl.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'adl',
    coding: ownCoding('adl-total', 'Katz ADL total score'),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [],
  }),
}
